import { BirthTranslate } from './birthTranslate.model';

const birthTranslatePTBR: BirthTranslate = {
  tab: {
    title: 'Partos',
    empty: 'Nenhum parto cadastrado para este cliente',
    add: 'Cadastrar parto',
  },
  card: {
    expectedBirthDate: 'Data provável do parto',
    birthDate: 'Nasceu em',
    babyName: 'Nome do bebê',
    deliveryMethod: 'Via de parto',
    location: 'Local',
    photographyWishes: 'Desejos para as fotos',
    noExpectedBirthDate: 'Sem data prevista',
    edit: 'Editar parto',
    delete: 'Excluir parto',
    confirmDelete: 'Excluir parto',
    confirmDeleteMessage: 'Tem certeza que deseja excluir este parto?',
    cancelDelete: 'Cancelar',
  },
  form: {
    titleCreate: 'Novo parto',
    titleEdit: 'Editar parto',
    expectedBirthDate: 'Data provável do parto',
    birthDate: 'Data do nascimento',
    babyName: 'Nome do bebê',
    deliveryMethod: 'Via de parto',
    deliveryMethodNone: 'Não definida',
    location: 'Local do parto',
    photographyWishes: 'Desejos para as fotos',
    submit: 'Salvar',
    clear: 'Limpar campos',
  },
  deliveryMethod: {
    NORMAL: 'Normal',
    CESAREAN_SCHEDULED: 'Cesárea agendada',
    CESAREAN_EMERGENCY: 'Cesárea de emergência',
    HOME: 'Domiciliar',
  },
  event: {
    field: 'Parto vinculado',
    none: 'Nenhum',
    optionWithBaby: '{{babyName}} — {{date}}',
    optionWithoutBaby: 'Parto — {{date}}',
  },
  errors: {
    expectedBirthDateInvalid: 'Data inválida',
    birthDateInvalid: 'Data inválida',
    babyNameTooLong: 'O nome do bebê deve ter no máximo 100 caracteres',
    photographyWishesTooLong:
      'Os desejos para as fotos devem ter no máximo 2000 caracteres',
  },
  toast: {
    created: 'Parto cadastrado com sucesso',
    updated: 'Parto atualizado com sucesso',
    deleted: 'Parto excluído com sucesso',
    error: 'Não foi possível salvar o parto',
  },
};

export default birthTranslatePTBR;
